// const API_URL = "http://127.0.0.1:8000/";
const API_URL = "https://api.hibigbi.com/"
const TOKEN = localStorage.getItem("ACCESS_TOKEN_USER");

export { API_URL, TOKEN };
